// extracted by mini-css-extract-plugin
module.exports = {"wire":"Wire__wire___HqICh","background":"Wire__background___zSYgo","isReference":"Wire__isReference___AzpWi","isSelected":"Wire__isSelected___JdAwc"};